import jQuery from "jquery";
import React, { useState } from "react";
import ReactTooltip from "react-tooltip";
import "rsuite/dist/rsuite.css";
import * as image from "../../../resources/images";
import { Rating } from "../../../utils/Packages";
import RoundProgress from "../../controls/RoundProgress";
import { Line } from "rc-progress";

const Schoolactivity = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [text, settext] = useState("View More");
  const chooseTab = (data) => {
    setActiveTab(data);
  };
  const [isActive, setActive] = useState(false);

  const toggledClass = () => {
    setActive(!isActive);
    if (text === "View More") {
      settext(<i className="fa-light fa-circle-minus mr-2"></i> + "View Less");
    } else {
      settext(<i className="fa-light fa-circle-plus mr-2"></i> + "View More");
    }
  };
  const datax = [
    "Eugenia",
    "Bryan",
    "Linda",
    "Nancy",
    "Lloyd",
    "Alice",
    "Julia",
    "Albert",
  ].map((item) => ({
    label: item,
    value: item,
    role: Math.random() > 0.5 ? "Owner" : "Guest",
  }));
  function compare(a, b) {
    let nameA = a.toUpperCase();
    let nameB = b.toUpperCase();

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  }
  const data = [
    "Eugenia",
    "Bryan",
    "Linda",
    "Nancy",
    "Lloyd",
    "Alice",
    "Julia",
    "Albert",
  ].map((item) => ({
    label: item,
    value: item,
    role: Math.random() > 0.5 ? "Owner" : "Guest",
  }));
  jQuery(".leftClosebar").on("click", function () {
    jQuery(this).parents(".TopicSpeclist").removeClass("JourneyCardShow");
  });
  jQuery(".courseJourneyCard").on("click", function () {
    jQuery(this).parents(".TopicSpeclist").addClass("JourneyCardShow");
  });
  jQuery(".CourseJourneyicon").on("click", function () {
    jQuery(this).parent(".coursejounercrditem").addClass("CourseJItemActive");
    jQuery(this)
      .parent(".coursejounercrditem")
      .siblings()
      .removeClass("CourseJItemActive");
  });
  const [otp, setotp] = useState("");
  const handleChange = (otp) => setotp(otp);
  return (
    <div div className="RootContent">
      <button
        type="button"
        className="btn btn-primary"
        data-toggle="modal"
        data-target="#schoolactivity12"
      >
        Launch demo modal
      </button>
      <div className="smallpopup ">
        <div className="modal fade" id="schoolactivity1" role="dialog">
          <div className="modal-dialog modal-lg">
            <div className="modal-content my_popup">
              <div className="modal-header">
                  <h2 className="flexone w-100">
                    <span>
                     Enter Your Password
                    </span>
                    <button className="closebtn" data-dismiss="modal">
                  
                     <i class="fa-regular fa-xmark"></i>
                    </button>
                  </h2>
              </div>
              <div className="modal-body paymentinfo p-0">
              <div className="myParent_profile">
              <div className="Abotitems flextwo">
              <div className="items_image mr-3">
                <img src={image.userProfile} alt="character_image" className="br-50 " />
              </div>
              <div className="aboutitemsdtl">
                <h2>Luca</h2>
                <p className="">Admin</p>
              </div>
              </div>
               <div class="input-group position-relative">
                 <label>Password<span class="mandatoryField">*</span></label>
                   <div class="form-group">
                    <input class="form-control " name="password" type="password" id="password" autocomplete="off" />
                  </div>
                <div>
                <span class="PasswordeyeIcon"><i class="fa-solid fa-eye-slash"></i></span>
              </div>
            </div>
           </div>
              </div>
              <div className="modal-footer">
              <div className="text-right">
                      <button
                        type="button"
                        className="mybutton"
                      >
                         Continue
                      </button>
                 </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       <div className="smallpopup ">
        <div className="modal fade" id="schoolactivity2" role="dialog">
          <div className="modal-dialog modal-lg">
            <div className="modal-content my_popup">
              <div className="modal-header">
                  <h2 className="flexone w-100">
                    <span>
                     Select a learner for enrollment
                    </span>
                    <button className="closebtn" data-dismiss="modal">
                  
                     <i class="fa-regular fa-xmark"></i>
                    </button>
                  </h2>
              </div>
              <div className="modal-body paymentinfo p-0">
              <div className="choose_profile">
              <div className="form-group  flexone w-100">
								<div className="flexone position-relative select_Profile_input w-100">
									<div aria-haspopup="true"
										className="pointer dropdownDiv flex w-100"
										aria-expanded="false"
										data-toggle="dropdown">
              <div className="Abotitems flextwo m-0 p-0 border-0">
               <div className="items_image mr-3">
                <img src={image.userProfile} alt="character_image" className="br-50 " />
               </div>
               <div className="aboutitemsdtl">
                   <p className="">Alex jr</p>
                </div>
              </div>
								    <div class="dropdwnicon pointer flexfive" href="#showUserPlan0" data-toggle="dropdown" aria-expanded="true"><i class="fa-regular fa-chevron-down"></i></div>
                  </div>
								  <ul className="dropdown-menu dropdown-menu-end lPDropdwnList" aria-labelledby="">
											<li>
											    react
											</li>			
									</ul>
								</div>
            	</div>
            </div>
           </div>
         
            
              <div className="modal-footer">
              <div className="text-right">
                      <button
                        type="button"
                        className="mybutton"
                      >
                         Continue
                      </button>
                 </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --------------------start here this code by alfaiz ansari for calander view --------------------------------------*/}
      <div className="smallpopup calendarSchedule">
        <div className="modal fade" id="schoolactivity3" role="dialog">
          <div className="">
            <div className="modal-content my_popup calendar_schedule_popup">
              <div className="modal-header">
                  <h2 className="flexone w-100">
                    <span>
                    📝 Define Your Goals & Key Results
                    </span>
                    <button className="closebtn" data-dismiss="modal">
                     <i class="fa-regular fa-xmark"></i>
                    </button>
                  </h2>
              </div>

              <div className="modal-body paymentinfo p-0">
                  <div className="flexone w-100"> 
                    <div className="select_Profile_input w-100 calendar_schedule_label mb-0 flexone">
                    <span class="dropdwnicon pointer flexfive" href="#showDimensionSkill0" aria-expanded="true"> <i class="fa-regular fa-chevron-left"></i></span>
                        <p className="text-center">Course 1: Relationship Building</p>
                        <span class="dropdwnicon pointer flexfive" href="#showDimensionSkill0" aria-expanded="true"> <i class="fa-regular fa-chevron-right"></i></span>
                    </div>
                  </div>
                  {/* 1 section */}
                  <div className="flexone w-100 mt-1 gap">
                    <div className="select_Profile_input w-10 calendar_schedule_label mt-1 mb-0">
                        <p className="text-center">Goals</p>
                    </div>
  
                    <div className="select_Profile_input w-90 calendar_schedule_checkbox mt-1 mb-0">
                      <div className="d-flex pl-2">
                       <div className="Ansoptions checkboxtyped">
            <label  className="selAnslabel ">
           
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
                        <p className="text-center ">Help Alex Jr build lifelong focus habits through structure and self-awareness.</p>
                      </div>
                    </div>
                  </div>

                  {/* 2 section */}
                  <div className="flexone w-100 mt-1 gap">
                    <div className="select_Profile_input w-10 calendar_schedule_label mt-1 mb-0">
                        <p className="text-center">KR 1</p>
                    </div>
  
                    <div className="select_Profile_input w-90 calendar_schedule_checkbox mt-1 mb-0">
                      <div className="d-flex pl-2">
                       <div className="Ansoptions checkboxtyped">
            <label  className="selAnslabel ">
      
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
                        <p className="text-center ">Help Alex Jr complete all lessons across 4 modules by 4th May 2025</p>
                      </div>
                    </div>
                  </div>

                  {/* 3 section */}
                  <div className="flexone w-100 mt-1 gap">
                    <div className="select_Profile_input w-10 calendar_schedule_label mt-1 mb-0">
                        <p className="text-center">KR 2</p>
                    </div>
  
                    <div className="select_Profile_input w-90 calendar_schedule_checkbox mt-1 mb-0">
                      <div className="d-flex pl-2">
                         <div className="Ansoptions checkboxtyped">
            <label  className="selAnslabel ">
     
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
                        <p className="text-center ">Help Alex Jr complete all lessons across 4 modules by 4th May 2025</p>
                      </div>
                    </div>
                  </div>

                  {/* 4 section */}
                  <div className="flexone w-100 mt-1 gap">
                    <div className="select_Profile_input w-10 calendar_schedule_label mt-1 mb-0">
                        <p className="text-center">KR 2</p>
                    </div>
  
                    <div className="select_Profile_input w-90 calendar_schedule_checkbox mt-1 mb-0">
                      <div className="d-flex pl-2">
                 <div className="Ansoptions checkboxtyped">
            <label  className="selAnslabel ">
    
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
                        <p className="text-center">Help Alex Jr complete all lessons across 4 modules by 4th May 2025</p>
                      </div>
                    </div>
                  </div>
<div class="modal-footer mt-3">

<div class="text-right"><a href="javacript:void(0)" className="mr-3">Skip</a><button type="button" class="mybutton">Next Courses</button></div></div>
                   {/* Calendar Days*/}
                   <div className="schedulecalender">
                  <div className="flexone w-100 mt-5">
                    <div className="calander-days week-day-only">
                          <p>Week</p>
                    </div>
                     <div className="calander-days">
                          <p>Monday</p>
                    </div>
                     <div className="calander-days">
                          <p>Tuesday</p>
                    </div>
                     <div className="calander-days">
                          <p>Wednesday</p>
                    </div>
                     <div className="calander-days">
                          <p>Thursday</p>
                    </div>
                     <div className="calander-days">
                          <p>Friday</p>
                    </div>
                     <div className="calander-days">
                          <p>Saturday</p>
                    </div>
                    <div className="calander-days">
                          <p>Sunday</p>
                    </div>
                  </div>

                  {/* Calendar Date */}
                  <div className="flexone w-100 mt-3">
                    {/* 1 secion */}
                    <div className="calander-date-min-div week">
                      <div className="calander-date-title week-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500 weekName">Week 1</p>
                    </div>

                    {/* 2 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 3 secion */}
                    <div className="calander-date-min-div active-date">
                      <div className="calander-date-title active-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <div className="d-flex justify-content-start pl-2">
                          <p className="pt-4 p4 fw-500 calander-date-sub-title">C1: Relationship Building aaaaaaa</p>
                      </div>
                      <div className="d-flex justify-content-start pt-2 pl-2">
                          <i className="fa fa-caret-right mr-1" aria-hidden="true"></i>
                          <p className="calander-date-sub-title1  p3 text-uppercase">M1: Self-Confidence</p>
                      </div>
                    </div>

                    {/* 4 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 5 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 6 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 7 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 8 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>  
                  </div>
                     <div className="flexone w-100 mt-3">
                    {/* 1 secion */}
                    <div className="calander-date-min-div week">
                      <div className="calander-date-title week-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500 weekName">Week 1</p>
                    </div>

                    {/* 2 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 3 secion */}
                    <div className="calander-date-min-div active-date">
                      <div className="calander-date-title active-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <div className="d-flex justify-content-start pl-2">
                          <p className="pt-4 p4 fw-500 calander-date-sub-title">C1: Relationship Building aaaaaaa</p>
                      </div>
                      <div className="d-flex justify-content-start pt-2 pl-2">
                          <i className="fa fa-caret-right mr-1" aria-hidden="true"></i>
                          <p className="calander-date-sub-title1  p3 text-uppercase">M1: Self-Confidence</p>
                      </div>
                    </div>

                    {/* 4 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 5 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 6 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 7 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 8 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>  
                  </div>
                  </div>
              </div>
         
            
              {/* <div className="modal-footer">
                <div className="text-right">
                      <button
                        type="button"
                        className="mybutton"
                      >
                         Continue
                      </button>
                 </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
         <div className="smallpopup calendarSchedule">
        <div className="modal fade" id="schoolactivity4" role="dialog">
          <div className="">
            <div className="modal-content my_popup calendar_schedule_popup">
              <div className="modal-header">
                  <h2 className="flexone w-100">
                    <span>
                  📝 Edit Your Plan
                    </span>
                    <button className="closebtn" data-dismiss="modal">
                     <i class="fa-regular fa-xmark"></i>
                    </button>
                  </h2>
              </div>

              <div className="modal-body paymentinfo p-0">
           <div className="editplaninformation">
            <ul>
              <li className="w-25">
                <p>Sessions Per Week:</p>
                <p><span className="pacetags">2 sessions</span></p>
              </li>
               <li className="w-25">
                <p>Duration Per Session:</p>
                <p><span className="pacetags">30 Minutes</span></p>
              </li>
               <li className="w-50">
                <p>Select two (2) Days you want to work on Bloomster.</p>
                <div className="defaultpacecheck">  
            <div className="Ansoptions checkboxtyped">
            <label  className="selAnslabel ">
            <span className="p2 lighttextcolor ">I’m Flexible (We select consecutive days including ‘Start date’ & ‘Sessions per week’).</span>
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div></div>
              </li>
            </ul>
           </div>

                   {/* Calendar Days*/}
                   <div className="schedulecalender">
                  <div className="flexone w-100 mt-5">
                    <div className="calander-days week-day-only">
                          <p>Week</p>
                    </div>
                     <div className="calander-days">
                          <p>Monday</p>
                    </div>
                     <div className="calander-days">
                          <p>Tuesday</p>
                    </div>
                     <div className="calander-days">
                          <p>Wednesday</p>
                    </div>
                     <div className="calander-days">
                          <p>Thursday</p>
                    </div>
                     <div className="calander-days">
                          <p>Friday</p>
                    </div>
                     <div className="calander-days">
                          <p>Saturday</p>
                    </div>
                    <div className="calander-days">
                          <p>Sunday</p>
                    </div>
                  </div>

                  {/* Calendar Date */}
                  <div className="flexone w-100 mt-3">
                    {/* 1 secion */}
                    <div className="calander-date-min-div week">
                      <div className="calander-date-title week-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500 weekName">Week 1</p>
                    </div>

                    {/* 2 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 3 secion */}
                    <div className="calander-date-min-div active-date">
                      <div className="calander-date-title active-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <div className="d-flex justify-content-start pl-2">
                          <p className="pt-4 p4 fw-500 calander-date-sub-title">C1: Relationship Building aaaaaaa</p>
                      </div>
                      <div className="d-flex justify-content-start pt-2 pl-2">
                          <i className="fa fa-caret-right mr-1" aria-hidden="true"></i>
                          <p className="calander-date-sub-title1  p3 text-uppercase">M1: Self-Confidence</p>
                      </div>
                    </div>

                    {/* 4 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 5 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 6 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 7 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 8 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>  
                  </div>
                     <div className="flexone w-100 mt-3">
                    {/* 1 secion */}
                    <div className="calander-date-min-div week">
                      <div className="calander-date-title week-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500 weekName">Week 1</p>
                    </div>

                    {/* 2 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 3 secion */}
                    <div className="calander-date-min-div active-date">
                      <div className="calander-date-title active-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <div className="d-flex justify-content-start pl-2">
                          <p className="pt-4 p4 fw-500 calander-date-sub-title">C1: Relationship Building aaaaaaa</p>
                      </div>
                      <div className="d-flex justify-content-start pt-2 pl-2">
                          <i className="fa fa-caret-right mr-1" aria-hidden="true"></i>
                          <p className="calander-date-sub-title1  p3 text-uppercase">M1: Self-Confidence</p>
                      </div>
                    </div>

                    {/* 4 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 5 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 6 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 7 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 8 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>  
                  </div>
                  </div>
              </div>
         
            
              {/* <div className="modal-footer">
                <div className="text-right">
                      <button
                        type="button"
                        className="mybutton"
                      >
                         Continue
                      </button>
                 </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
           <div className="smallpopup calendarSchedule">
        <div className="modal fade" id="schoolactivity5" role="dialog">
          <div className="">
            <div className="modal-content my_popup calendar_schedule_popup">
              <div className="modal-header">
                  <h2 className="flexone w-100">
                    <span>
                   📝 Plan Goals
                   <span className="infoicons">
                    <img src={image.newinfoicon} alt="" className="newinfoicons ml-3" />
                    <div className="mytoottiptxt p-3">
                      <p className="p1 mb-1">Custom KRs</p>
                      <p className="p2">You can edit and customize KR 4 and 5, Hover over them to edit them for yourselves.</p>
                    </div>
                   </span>
                    </span>
                    <button className="closebtn" data-dismiss="modal">
                     <i class="fa-regular fa-xmark"></i>
                    </button>
                  </h2>
              </div>

           <div class="modal-body paymentinfo p-0">
           <div class="flexone w-100">
           <div class="select_Profile_input w-100 calendar_schedule_label mb-0 flexone">
           <span class="dropdwnicon pointer flexfive" href="#showDimensionSkill0" aria-expanded="true"> 
            <i class="fa-regular fa-chevron-left"></i></span><p class="text-center">Course 1: Relationship Building Basics</p><span class="dropdwnicon pointer flexfive" href="#showDimensionSkill0" aria-expanded="true"> <i class="fa-regular fa-chevron-right"></i>
            </span></div></div><div class="flexone w-100 mt-1 gap">
            <div class="select_Profile_input w-10 calendar_schedule_label mt-1 mb-0">
            <p class="text-center">Goals</p></div>
            <div class="select_Profile_input w-90 calendar_schedule_checkbox mt-1 mb-0"><div class="d-flex pl-2">
            <div class="Ansoptions checkboxtyped"><label class="selAnslabel m-0">
            <p class="text-center ">Help Alex Jr build lifelong focus habits through structure and self-awareness.</p>
            <input type="checkbox" name="knowledgecheck"/>
            <span class="checkmark"></span></label></div></div>
            </div></div><div class="flexone w-100 mt-1 gap">
            <div class="select_Profile_input w-10 calendar_schedule_label mt-1 mb-0"><p class="text-center">KR 1</p></div><div class="select_Profile_input w-90 calendar_schedule_checkbox mt-1 mb-0">
            <div class="d-flex pl-2"><div class="Ansoptions checkboxtyped"><label class="selAnslabel m-0"><p class="text-center ">Help Alex Jr complete all lessons across 4 modules by 4th May 2025</p><input type="checkbox" name="knowledgecheck" /><span class="checkmark"></span></label></div></div></div></div><div class="flexone w-100 mt-1 gap">
            <div class="select_Profile_input w-10 calendar_schedule_label mt-1 mb-0"><p class="text-center">KR 2</p></div><div class="select_Profile_input w-90 calendar_schedule_checkbox mt-1 mb-0">
            <div class="d-flex pl-2"><div class="Ansoptions checkboxtyped"><label class="selAnslabel m-0"><p class="text-center ">Help Alex Jr complete all lessons across 4 modules by 4th May 2025</p>
            <input type="checkbox" name="knowledgecheck" /><span class="checkmark"></span></label></div></div></div></div><div class="flexone w-100 mt-1 gap">
            <div class="select_Profile_input w-10 calendar_schedule_label mt-1 mb-0"><p class="text-center">KR 3</p></div><div class="select_Profile_input w-90 calendar_schedule_checkbox mt-1 mb-0">
            <div class="d-flex pl-2"><div class="Ansoptions checkboxtyped"><label class="selAnslabel m-0"><p class="text-center">Help Alex Jr complete all lessons across 4 modules by 4th May 2025</p>
            <input type="checkbox" name="knowledgecheck"/><span class="checkmark"></span></label></div></div></div></div><div class="flexone w-100 mt-1 gap">
            <div class="select_Profile_input w-10 calendar_schedule_label mt-1 mb-0"><p class="text-center">KR 4</p>
            </div><div class="select_Profile_input w-90 calendar_schedule_checkbox mt-1 mb-0">
            <div class="d-flex ">
            <div class="input-group">
            <div class="form-group flextwo">
            <input type="text" class="form-control w-75 p-0" placeholder="You can add Your Kra" />
            <span className="textrelatedicons">
            <span className="savedicon"><i class="fa-solid fa-check"></i></span>
             <span className="cleartxticon"><i class="fa-solid fa-xmark-large"></i></span>
             </span>
            </div>
            </div></div></div></div><div class="flexone w-100 mt-1 gap"><div class="select_Profile_input w-10 calendar_schedule_label mt-1 mb-0"><p class="text-center">KR 4</p></div>
            <div class="select_Profile_input w-90 calendar_schedule_checkbox mt-1  mb-0"><div class="d-flex "><div class="input-group">
            <div class="form-group"><input type="text" class="form-control w-80" placeholder="You can add Your Kra" /></div></div></div></div></div>
            <div class="modal-footer disablesd_button mt-3">
            <div class="text-right"><a href="javacript:void(0) " class="mr-3 false">Skip</a><button type="button " class="mybutton secondtpebtn">Next Courses</button></div></div></div>
         
            
              {/* <div className="modal-footer">
                <div className="text-right">
                      <button
                        type="button"
                        className="mybutton"
                      >
                         Continue
                      </button>
                 </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
  <div className="smallpopup notoficationsmalpoup ">
        <div className="modal fade" id="schoolactivity6" role="dialog">
          <div className="modal-dialog modal-lg">
            <div className="modal-content my_popup p-0">
              <div className="modal-body paymentinfo p-0">
               <div className="notificationbar">
                <Line percent={50} strokeWidth={1} strokeColor="#107C10" />
                 <p className="flexone p1"><span><img src={image.notification_check} className="mr-2" alt="check "/>KR Successfully Updated</span> <span className="Acrntxt">Retry<span></span></span></p>
               </div>
              </div>
               <div className="modal-body paymentinfo p-0">
               <div className="notificationbar">
                <Line percent={50} strokeWidth={1} strokeColor="#FF9900" />
                 <p className="flexone p1"><span><img src={image.notificationWarningIcon} className="mr-2" alt="check "/>Toast Status Goes Here</span> <span className="Acrntxt">Retry<span></span></span></p>
               </div>
              </div>
               <div className="modal-body paymentinfo p-0">
               <div className="notificationbar">
                <Line percent={50} strokeWidth={1} strokeColor="#C50F1F" />
                 <p className="flexone p1"><span><img src={image.notification_Error} className="mr-2" alt="check "/>Toast Status Goes Here</span> <span className="Acrntxt">Retry<span></span></span></p>
               </div>
              </div>
               <div className="modal-body paymentinfo p-0">
               <div className="notificationbar">
                <Line percent={50} strokeWidth={1} strokeColor="#828282" />
                 <p className="flexone p1"><span><img src={image.notification_calender} className="mr-2" alt="check "/>Toast Status Goes Here</span> <span className="Acrntxt">Retry<span></span></span></p>
               </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div className="smallpopup ondiscountpopup newuipopupchanges">
        <div className="modal fade" id="schoolactivity7" role="dialog">
          <div className="modal-dialog modal-lg">
            <div className="modal-content my_popup p-0">
              <div className="modal-body paymentinfo p-0">
              <div className="discount_poup flexone">
                <div className="leftSidepop">
                  <img src={image.Image_Placeholder} />
                                  </div>
                <div className="rightsidepop">
                 <div className={`mytabList  twotabs`}>
                 <ul className="flexthree">
                    <li className={`w-50 text-center Active_tab"}`}>
                         Yearly                             
                    </li>
                     <li className={`w-50 text-center "}`}>
                         Monthly                             
                    </li>
                    </ul>
                </div>
                <div className="">
                  <div class="Ansoptions">
                   <label class="selAnslabel Active_discount">
                      <div className="discountcrd">
                      <p className="flexone">
                         <span className="dispercent">50% Discount</span>   <span className="discounamount"> <strong>$24</strong> / month</span>
                      </p>
                      <p className="billedperyear flexone"><span>Billed Yearly</span><span>$288 / year</span></p>
                      </div>
                      <input type="radio" name="knowledgecheck"/>
                      <span class="checkmark"></span>
                    </label>
                  </div>
                   <div class="Ansoptions">
                   <label class="selAnslabel ">
                      <div className="discountcrd">
                      <p className="flexone">
                         <span className="dispercent">25% Discount</span>   <span className="discounamount"> <strong>$24</strong> / month</span>
                      </p>
                      <p className="billedperyear flexone"><span>Billed Yearly</span><span>$288 / year</span></p>
                      </div>
                      <input type="radio" name="knowledgecheck"/>
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
                <div className="benifits pt-3">
                <p className="p3 mb-3">Added Benefits:</p>
                  <ul>
                    <li className="flexthree"><i class="fa-solid fa-check mr-1"></i>For one full year on any plan</li>
                    <li className="flexthree"><i class="fa-solid fa-check mr-1"></i>Complete one (1) course and do one (1) 30-minute feedback call.</li>
                  </ul>
                </div>
                <div className="modal-footer mt-3 pt-3">
                  <div class="BDsubmitbutton flexone" >
                  <a href="#" className="mr-3">Continue With Free</a>
                   <button type="submit" class="btn-blue btn-login d-block mb-5  ">Subscribe To [Offer]</button>
                   </div>
                   </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
         <div className="smallpopup ondiscountpopup newuipopupchanges">
        <div className="modal fade" id="schoolactivity7" role="dialog">
          <div className="modal-dialog modal-lg">
            <div className="modal-content my_popup p-0">
              <div className="modal-body paymentinfo p-0">
              <div className="discount_poup flexone">
                <div className="leftSidepop">
                  <img src={image.Image_Placeholder} />
                                  </div>
                <div className="rightsidepop">
                 <div className={`mytabList  twotabs`}>
                 <ul className="flexthree">
                    <li className={`w-50 text-center Active_tab"}`}>
                         Yearly                             
                    </li>
                     <li className={`w-50 text-center "}`}>
                         Monthly                             
                    </li>
                    </ul>
                </div>
                <div className="">
                  <div class="Ansoptions">
                   <label class="selAnslabel Active_discount">
                      <div className="discountcrd">
                      <p className="flexone">
                         <span className="dispercent">50% Discount</span>   <span className="discounamount"> <strong>$24</strong> / month</span>
                      </p>
                      <p className="billedperyear flexone"><span>Billed Yearly</span><span>$288 / year</span></p>
                      </div>
                      <input type="radio" name="knowledgecheck"/>
                      <span class="checkmark"></span>
                    </label>
                  </div>
                   <div class="Ansoptions">
                   <label class="selAnslabel ">
                      <div className="discountcrd">
                      <p className="flexone">
                         <span className="dispercent">25% Discount</span>   <span className="discounamount"> <strong>$24</strong> / month</span>
                      </p>
                      <p className="billedperyear flexone"><span>Billed Yearly</span><span>$288 / year</span></p>
                      </div>
                      <input type="radio" name="knowledgecheck"/>
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
                <div className="benifits pt-3">
                <p className="p3 mb-3">Added Benefits:</p>
                  <ul>
                    <li className="flexthree"><i class="fa-solid fa-check mr-1"></i>For one full year on any plan</li>
                    <li className="flexthree"><i class="fa-solid fa-check mr-1"></i>Complete one (1) course and do one (1) 30-minute feedback call.</li>
                  </ul>
                </div>
                <div className="modal-footer mt-3 pt-3">
                  <div class="BDsubmitbutton flexone" >
                  <a href="#" className="mr-3">Continue With Free</a>
                   <button type="submit" class="btn-blue btn-login d-block mb-5  ">Subscribe To [Offer]</button>
                   </div>
                   </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div  className="modal fade d-block show guidepopups"
            id="schoolactivity8"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
          >
            <div className="modal-dialog  modal-lg">
              <div className="modal-content">
                <div className={`GuidePopupWrap`}>
                  <h3>HIi</h3>
      
                  <p
                    className="mt-2 mb-3"
                   
                  >wnwekjfb vker erver jbr tgo jebe</p>
                  <div className="flex">
                   
                      <button
                        type="button"
                        
                        className="btn btn-primary"
                      >
                        Skip
                      </button>
                    
                    <div className="">
                      <span className="ActiveGuide text-light">
                       1 of 10
                      </span>
                    </div>{" "}
                    <button
                      type="button"
                    
                      className="btn btn-primary "
                    >
                      button
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
         <div className="smallpopup newuipopupchanges badgesdtlpopup">
        <div className="modal fade" id="schoolactivity11" role="dialog">
          <div className="modal-dialog modal-lg">
            <div className="modal-content my_popup">
                <div className="modal-header">
                  <h5 className="flexone w-100">
                    <span>
                      Achievement Centre
                    </span>
                    <button className="closebtn" data-dismiss="modal">
                     <i class="fa-regular fa-xmark"></i>
                    </button>
                  </h5>
              </div>
              <div className="modal-body paymentinfo p-0">
               <div className="badges_popup text-left" >
                
                <h3 className="mt-3 mb-3">Developing Super-Human Problem Skills</h3>
               <div className="badgexlistitem">
                 <ul>
                  <li className="flexthree">
                    <div className="mr-3">
                    <img src={image.badges_icons1} />
                    </div>
                    <div className="text-left">
                      <h4 className="h-4">Badge Name</h4>
                      <p>One Line Badge Description</p>
                    </div>

                  </li>
                <li className="flexthree">
                    <div className="mr-3">
                    <img src={image.badges_icons1} />
                    </div>
                    <div className="text-left">
                      <h4 className="h-4">Badge Name</h4>
                      <p>One Line Badge Description</p>
                    </div>

                  </li>

                 </ul>
                </div>
                {/* <p className="p2 lighttextcolor">Enroll in a course to view your dashboard</p> */}
               </div>
           </div>
         
            
              <div className="modal-footer justify-content-right">
              <div className="text-center mt-3 pt-3">
                      <button
                        type="button"
                        className="mybutton"
                      >
                       Exit
                      </button>
                 </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="smallpopup newuipopupchanges badgesdtlpopup myinstallapp">
        <div className="modal fade" id="schoolactivity12" role="dialog">
          <div className="modal-dialog modal-lg">
            <div className="modal-content my_popup">
                <div className="modal-header">
                  <h5 className="flexone w-100">
                  
                    <button className="closebtn" data-dismiss="modal">
                     {/* <i class="fa-regular fa-xmark"></i> */}
                    </button>
                  </h5>
              </div>
              <div className="modal-body paymentinfo p-0">
               <div className="install_appwrap">
                <div className="bloomster_logo">
                  <img src={image.newvickylogo} alt="logo" />
                      <h3>Enjoy a Better Experience!</h3>
                      <p>Install our mobile app for faster access and smoother navigation.</p>
                      {/* <p><a href="https://apps.apple.com/us/app/bloomster/id6474612652">Bloomster</a></p> */}
                  <div className="appbtns">
                   <div class="btn-box"><a href="https://apps.apple.com/us/app/bloomster/id6474612652"> 
                   <img alt="IOS" src="https://bloomster.com/hubfs/website-pages-images/Applestore.png"  />
                    </a> <a href="https://play.google.com/store/apps/details?id=com.bluffy.bloomster" > <img src="https://bloomster.com/hubfs/website-pages-images/Playstore.png" alt="ANDROID" /> </a></div>
                  </div>
                  <p><a href="https://apps.apple.com/us/app/bloomster/id6474612652">Or, Continue in Browser</a></p>
                </div>
               </div>
           </div>
         
            
            
            </div>
          </div>
        </div>
      </div>

      {/* end here this code by alfaiz ansari for calander view */}
      </div>

  );
};

export default Schoolactivity;